/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { FallbackProps } from 'react-error-boundary';

export enum MotorsportsErrorType {
  Unauthenticated = 'unauthenticated',
  SessionNotFound = 'sessionNotFound',
  EventNotFound = 'eventNotFound',
  ImageNotFound = 'imageNotFound',
  AudioNetworkError = 'audioNetworkError',
  Unknown = 'unknown',
}

export interface MotorsportsErrorFallbackProps extends FallbackProps {
  error: any;
}

export class MotorsportsError extends Error {
  readonly type: MotorsportsErrorType;
  constructor(message: string, type: MotorsportsErrorType, options?: ErrorOptions) {
    super(message, options);
    this.type = type;
    this.name = this.constructor.name;
  }
}
